import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ObservableSyncService } from '../sync/observable-sync.service';
import { ChangeTyped, mapSnapshotToDtos, QueryService, SAVED_SEARCH_STORE } from '@damofire/data-commons';
import { SavedSearch } from './saved-search.dto';
import { ObservableSavedSearchService } from './saved-search-observable.service';

@Injectable()
export class IdbObservableSavedSearchService extends ObservableSavedSearchService {
  constructor(protected readonly observableSyncService: ObservableSyncService<SavedSearch>) {
    super();
  }

  list(divisionId: string): Observable<SavedSearch[]> {
    const previousResults: SavedSearch[] = [];
    return this.observableSyncService.toObservable(SAVED_SEARCH_STORE, divisionId, this.filterNonSystem).pipe(
      map((changes) => {
        mapSnapshotToDtos(previousResults, changes);
        return QueryService.applySort(previousResults, { sort: { name: 'asc' } });
      }),
    );
  }

  get(divisionId: string, id: string): Observable<SavedSearch> {
    return this.observableSyncService.toObservableById(SAVED_SEARCH_STORE, divisionId, id);
  }

  private filterNonSystem(savedSearches: SavedSearch[]): ChangeTyped<SavedSearch>[] {
    return savedSearches.filter((r) => !r.system);
  }
}
